import { useStore } from 'zustand';
import type { EagGridState } from './createEagGridStore';
import { useEagGridStore } from './useEagGridStore';
export function useEagGridSelector<T>(selector: (state: EagGridState) => T): T {
  const store = useEagGridStore();
  return useStore(store, selector);
}